import { forwardRef, type Ref, type SVGProps } from "react";
const IconAppHeartOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16 27.2a.934.934 0 1 0 0-1.867.934.934 0 0 0 0 1.867m4.366-11.328c.42-.505.673-1.094.673-1.683s-.169-1.178-.505-1.682a2.386 2.386 0 0 0-3.365 0l-1.01 1.01-1.01-1.01c-.504-.421-1.093-.673-1.682-.673s-1.262.252-1.683.673a2.35 2.35 0 0 0-.673 1.682c0 .673.253 1.262.673 1.683l4.291 4.29zM13.198 5.733a.934.934 0 1 1-1.867 0 .934.934 0 0 1 1.867 0m3.736.934h-1.868a.934.934 0 1 1 0-1.867h1.868a.934.934 0 1 1 0 1.867"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.462 2h13.076a1.873 1.873 0 0 1 1.868 1.867v24.266A1.873 1.873 0 0 1 22.538 30H9.462a1.873 1.873 0 0 1-1.868-1.867V3.867A1.873 1.873 0 0 1 9.462 2m0 26.133h13.076V24.4H9.462zm13.076-5.6H9.462V9.467h13.076zM9.462 7.6h13.076V3.867H9.462z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconAppHeartOutlineSVG);
ForwardRef.displayName = "IconAppHeartOutline";
export { ForwardRef as IconAppHeartOutline };
